// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Parser = require("../Data.Argonaut.Parser/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var getTutorialSteps = function (v) {
    return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note("Missing main.json file!")(Data_Map_Internal.lookup(Data_Ord.ordString)("main.json")(v.files)))(function (file) {
        return Control_Bind.bind(Data_Either.bindEither)(Control_Bind.bindFlipped(Data_Either.bindEither)(Data_Argonaut_Decode_Class.decodeJson(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonMaybe(Data_Argonaut_Decode_Class.decodeArray(Lunarbox_Data_Editor_FunctionName.decodeJsonFunctionName)))(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeRecord(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonCons(Data_Argonaut_Decode_Class.decodeJsonString)(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
            return "title";
        }))()())(new Data_Symbol.IsSymbol(function () {
            return "content";
        }))()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(new Data_Symbol.IsSymbol(function () {
            return "steps";
        }))()())(new Data_Symbol.IsSymbol(function () {
            return "allowedNodes";
        }))()())()))(Data_Argonaut_Parser.jsonParser(file.content)))(function (v1) {
            return Control_Bind.bind(Data_Either.bindEither)(Data_Traversable["for"](Data_Either.applicativeEither)(Data_Traversable.traversableArray)(v1.steps)(function (v2) {
                return Control_Bind.bind(Data_Either.bindEither)(Data_Either.note("Missing slide: " + v2.content)(Data_Map_Internal.lookup(Data_Ord.ordString)(v2.content)(v.files)))(function (slide) {
                    return Control_Applicative.pure(Data_Either.applicativeEither)({
                        content: slide.content,
                        title: v2.title
                    });
                });
            }))(function (steps) {
                return new Data_Either.Right({
                    config: v1,
                    steps: steps
                });
            });
        });
    });
};
module.exports = {
    getTutorialSteps: getTutorialSteps
};
